// 专门出来用户相关的网络请求
import request from "@/utils/request";

/**
 * @description: 用户登录
 */
export function login(data) {
  return request({
    method: "post",
    url: "/user/login",
    data,
  });
}

// 修改密码
export function npsw(data) {
  // 超级管理员
  // return request({
  //   method: "post",
  //   url: "/updatepwd",
  //   data,
  // });
  // 操作员
  return request({
    method: "post",
    url: "/project/updatepwd",
    data,
  });
}

/**
 * @description: 获取用户列表
 */
export function getUserList(data) {
  return request({
    method: "get",
    url: "/project/userlist", // 超级管理用户/userlist
    params: data,
    data: {},
  });
}
/**
 * @description: 添加用户
 */
export function add(data) {
  // 超级管理员
  // return request({
  //   method: "post",
  //   url: "/adduser",
  //   data,
  // });
  // 操作员
  return request({
    method: "post",
    url: "/project/adduser",
    data,
  });
}
/**
 * @description: 修改用户
 */
export function change(data) {
  // 超级管理员
  // return request({
  //   method: "post",
  //   url: "/update",
  //   data,
  // });
  // 操作员
  return request({
    method: "post",
    url: "project/updateuser",
    data,
  });
}

/**
 * @description: 删除用户
 */
export function del(data) {
  // 超级管理员
  // return request({
  //   method: "get",
  //   url: "/delete",
  //   params: data,
  //   data,
  // });
  // 操作员
  return request({
    method: "get",
    url: "/project/deleteuser",
    params: data,
    data,
  });
}

/**
 * @description: 查询用户
 */
export function serch(data) {
  return request({
    method: "get",
    url: "/userinfo/username",
    params: data,
    data,
  });
}
// 修改头像
export function changeAvatar(data) {
  // 超级管理员
  // return request({
  //   method: "post",
  //   url: "/updateavatar",
  //   data,
  // });
  // 操作员
  return request({
    method: "post",
    url: "/project/updateavatar",
    data,
  });
}
// 获取角色列表
export function getRoleList(data) {
  return request({
    method: "get",
    url: "/rolelist",
    params: data,
    data: {},
  });
}
// 修改用户菜单
export function changeMenu(data) {
  return request({
    method: "post",
    url: "/project/updatemenu",
    data,
  });
}
// 获取用户菜单
export function getMenuList(data) {
  return request({
    method: "get",
    url: "/project/menu",
    params: data,
    data: {},
  });
}
// 添加用户菜单
export function addMenu(data) {
  return request({
    method: "post",
    url: "/project/addmenu",
    data,
  });
}
// 删除用户菜单
export function delMenu(data) {
  return request({
    method: "get",
    url: "/project/deletemenu",
    params: data,
    data: {},
  });
}
export function getRoleMenu(data) {
  // return request({
  //   method: "get",
  //   url: "/rolemenu",
  //   params: data,
  //   data: {},
  // });
  return request({
    method: "get",
    url: "/project/rolemenu",
    params: data,
    data: {},
  });
}

export function changeRole(data) {
  return request({
    method: "post",
    url: "/project/changerole",
    data,
  });
}
